module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/location-icon-white-761dc47ae853b156291b22faa761a943.png";